var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ConfigureComponentBase } from '../../../../../../../shared/configure-component-base';
import { AutoRenameTypeEnum } from '../../../variable/batch-import-modal/auto-rename-type-enum';
import { finalize } from 'rxjs/operators';
var RenameAlarmChooseModalComponent = /** @class */ (function (_super) {
    __extends(RenameAlarmChooseModalComponent, _super);
    function RenameAlarmChooseModalComponent(injector, alarmRegistrationsServiceProxy) {
        var _this = _super.call(this, injector) || this;
        _this.alarmRegistrationsServiceProxy = alarmRegistrationsServiceProxy;
        _this.importSuccessEvent = new EventEmitter();
        _this.active = false;
        _this.importing = false;
        _this.enumAutoRenameType = AutoRenameTypeEnum;
        _this.selectedEnumHandleDuplicateNameRule = _this.enumAutoRenameType.NameGroupNameDataSourceName;
        return _this;
    }
    RenameAlarmChooseModalComponent.prototype.show = function (dataSourceId, isImportAll, refAlarmIdArray) {
        this.isImportAll = isImportAll;
        this.dataSourceId = dataSourceId;
        this.refAlarmIdArray = refAlarmIdArray;
        this.active = true;
        this.modal.show();
    };
    RenameAlarmChooseModalComponent.prototype.import = function () {
        var _this = this;
        if (!this.dataSourceId) {
            abp.notify.warn(this.lc('HaventSelectDataSource'));
            return;
        }
        this.importing = true;
        this.alarmRegistrationsServiceProxy.batchImportAlarms({
            configureId: this.configureId,
            dataSourceId: this.dataSourceId,
            isImportAll: this.isImportAll,
            fBoxAlarmIds: this.refAlarmIdArray,
            enumHandleDuplicateNameRule: this.selectedEnumHandleDuplicateNameRule.valueOf()
        })
            .pipe(finalize(function () { return _this.importing = false; }))
            .subscribe(function () {
            abp.notify.success(_this.l('SavedSuccessfully'));
            _this.close();
            _this.importSuccessEvent.emit();
        });
    };
    RenameAlarmChooseModalComponent.prototype.close = function () {
        this.modal.hide();
        this.selectedEnumHandleDuplicateNameRule = this.enumAutoRenameType.NameGroupNameDataSourceName;
        this.refAlarmIdArray = null;
        this.active = false;
        this.importing = false;
    };
    __decorate([
        ViewChild('rename', { static: false })
    ], RenameAlarmChooseModalComponent.prototype, "modal", void 0);
    __decorate([
        Output()
    ], RenameAlarmChooseModalComponent.prototype, "importSuccessEvent", void 0);
    __decorate([
        Input()
    ], RenameAlarmChooseModalComponent.prototype, "configureId", void 0);
    RenameAlarmChooseModalComponent = __decorate([
        Component({
            selector: 'rename-alarm-choose-modal',
            template: "<div bsModal #rename=\"bs-modal\" id=\"rename\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"rename\" aria-hidden=\"true\" [config]=\"{backdrop: 'static'}\" allow-drag> <div class=\"modal-dialog design-rename-modal-dialog\"> <div class=\"modal-content  fe-modal-container\"> <div class=\"modal-header fe-modal-header\"> <h4 class=\"modal-title fe-modal-header-title\"> <span>{{lc(\"AutoAlarmRename\")}}</span> </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"close()\">×</div> </div> <form *ngIf=\"active\" #renameForm=\"ngForm\" (ngSubmit)=\"import()\"> <div class=\"modal-body\"> <div class=\"rule-tips\"> <label>{{lc('AlarmRenameRuleChooseText')}}</label> </div> <div class=\"rule-select\"> <label>{{lc('AlarmNameG')}}</label> <span> = </span> <select name=\"renameRule\" [(ngModel)]=\"selectedEnumHandleDuplicateNameRule\"> <option [ngValue]=\"enumAutoRenameType.NameGroupNameDataSourceName\" selected> {{lc('AlarmNameGroupNameDataSourceName')}}</option> <option [ngValue]=\"enumAutoRenameType.AutoIncrement\">{{lc('AlarmNameAutoIncrease')}} </option> </select> </div> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"importing\" [buttonBusy]=\"importing\" [busyText]=\"l('SavingWithThreeDot')\" (click)=\"import()\"> {{lc(\"Confirm\")}} </button> <button [disabled]=\"importing\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"close()\"> {{l(\"Cancel\")}} </button> </div> </div> </form> </div> </div> </div> ",
            styles: [".design-rename-modal-dialog { min-width: 550px; .modal-body { padding-left: 50px; .rule-tips { margin-bottom: 12px; } .rule-select { display: inline-block; vertical-align: middle; height: 31px; label { height: 20px; } select { height: 31px; } } } .fe-modal-container .fe-modal-header{ border-bottom: 1px solid #f4f4f4; .fe-modal-header-title{ line-height: 50px; } } select option{ color: rgba(0,0,0,0.6); } } "],
        })
    ], RenameAlarmChooseModalComponent);
    return RenameAlarmChooseModalComponent;
}(ConfigureComponentBase));
export { RenameAlarmChooseModalComponent };
